import { writable } from "../util/customStores";
import Instruction from "../model/Instruction";
import BinaryValue from "./BinaryValue";
import { FIRST_ADDRESS } from "../util/ram";
import { WORD_SIZE } from "../util/cpu";
/** Class that represents the CPU state */
export default class Cpu {
    constructor() {
        this.instructionRegister = writable(Instruction.NOP);
        this.programCounter = writable(new BinaryValue(8, FIRST_ADDRESS));
        this.increment = writable(new BinaryValue(8, WORD_SIZE));
        this.alu1 = writable(new BinaryValue(16, 0));
        this.alu2 = writable(new BinaryValue(16, 0));
        this.aluOperation = writable("");
        this.aluResult = writable(new BinaryValue(16, 0));
        this.accumulator = writable(new BinaryValue(16, 0));
        this.zeroFlag = writable(true);
        this.negativeFlag = writable(false);
        this.isJumping = writable(false);
        this.isHalting = writable(false);
    }
    /** Resets all cpu values to their default values */
    reset() {
        this.instructionRegister.set(Instruction.NOP);
        this.programCounter.set(new BinaryValue(8, FIRST_ADDRESS));
        this.increment.set(new BinaryValue(8, WORD_SIZE));
        this.alu1.set(new BinaryValue(16, 0));
        this.alu2.set(new BinaryValue(16, 0));
        this.aluOperation.set("");
        this.aluResult.set(new BinaryValue(16, 0));
        this.accumulator.set(new BinaryValue(16, 0));
        this.zeroFlag.set(true);
        this.negativeFlag.set(false);
        this.isJumping.set(false);
        this.isHalting.set(false);
    }
    set(component, value) {
        switch (component) {
            case CpuComponent.IR:
                this.instructionRegister.set(value);
                break;
            case CpuComponent.PC:
                this.programCounter.set(value);
                break;
            case CpuComponent.INC:
                this.increment.set(value);
                break;
            case CpuComponent.ALU1:
                this.alu1.set(value);
                break;
            case CpuComponent.ALU2:
                this.alu2.set(value);
                break;
            case CpuComponent.ALU_OP:
                this.aluOperation.set(value);
                break;
            case CpuComponent.ALU_RESULT:
                this.aluResult.set(value);
                break;
            case CpuComponent.ACC:
                this.accumulator.set(value);
                break;
            case CpuComponent.SW_Z:
                this.zeroFlag.set(value);
                break;
            case CpuComponent.SW_N:
                this.negativeFlag.set(value);
                break;
            case CpuComponent.HALTING:
                this.isHalting.set(value);
                break;
            case CpuComponent.JUMPING:
                this.isJumping.set(value);
                break;
        }
    }
}
export var CpuComponent;
(function (CpuComponent) {
    CpuComponent["IR"] = "IR";
    CpuComponent["PC"] = "PC";
    CpuComponent["INC"] = "INC";
    CpuComponent["ALU1"] = "ALU1";
    CpuComponent["ALU2"] = "ALU2";
    CpuComponent["ALU_OP"] = "ALU_OP";
    CpuComponent["ALU_RESULT"] = "ALU_RESULT";
    CpuComponent["ACC"] = "ACC";
    CpuComponent["SW_Z"] = "SW_Z";
    CpuComponent["SW_N"] = "SW_N";
    CpuComponent["HALTING"] = "HALTING";
    CpuComponent["JUMPING"] = "JUMPING";
})(CpuComponent || (CpuComponent = {}));
